import React from 'react';
import { Box, Modal, Card, CardContent, Button, Portal, Typography, Stack, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { useMutation } from 'react-fetching-library';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

import { getSaleCalendarReportAction } from '../../../../services/request';
import { formatDate } from '../../../../services/functions';
import { useSaleCalendar } from '../SaleCalendarContext';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function SaleCalendarReportModal ({ open, handleClose }) {
  const { mutate, loading } = useMutation(getSaleCalendarReportAction);
  const { saleCalendarId, selectedResort } = useSaleCalendar();
  const now = new Date();
  const firstDayOfMonth = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
  const lastDayOfMonth = formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));
  const [startDate, setStartDate] = React.useState(firstDayOfMonth);
  const [endDate, setEndDate] = React.useState(lastDayOfMonth);

  const handleSubmit = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutate(saleCalendarId, startDate, endDate);
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10); // Formatowanie na 'YYYY-MM-DD'
      a.download = `Raport Kalendarz Sprzedażowy - ${selectedResort.toUpperCase()} - ${formattedDate}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  return (
    <Portal>
      <Modal open={open} onClose={handleClose} id="block-modal">
        <Card sx={{ ...style, width: '500px' }}>
          <CardContent>
            <Typography variant="h6" textAlign="center" color="primary">
              Wybierz przedział czasowy
            </Typography>
            <Box height={20} />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack direction="row" spacing={3} alignItems="center" mb={4}>
                <Typography>Data od</Typography>
                <DatePicker
                  inputFormat="yyyy-MM-dd"
                  mask="____-__-__"
                  label="Data Od"
                  autoOk
                  id="startDate"
                  name="startDate"
                  value={startDate}
                  onChange={val => setStartDate(formatDate(val))
                  }
                  renderInput={props => <TextField {...props} />}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </Stack>
              <Stack direction="row" spacing={3} alignItems="center">
                <Typography>Data do</Typography>
                <DatePicker
                  inputFormat="yyyy-MM-dd"
                  mask="____-__-__"
                  label="Data Do"
                  autoOk
                  id="endDate"
                  name="endDate"
                  value={endDate}
                  onChange={val => setEndDate(formatDate(val))
                  }
                  renderInput={props => <TextField {...props} />}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </Stack>
            </LocalizationProvider>
            <Box height={20} />
            <Button variant="contained" onClick={handleSubmit} disabled={loading}>Wygeneruj</Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
